import { CategoryData } from './residentialCategories'

export const commercialCategories: CategoryData[] = [
  {
    route: '/6m8/commercial-mailboxes-lockers.html',
    label: 'Commercial Mailboxes & Lockers',
    sourceUrl:
      'https://www.midatlanticmailboxes.com/6m8/commercial-mailboxes-lockers.html',
    total: 257,
    products: [
      {
        title: 'Florence Verticals 1250-3-Alum',
        sku: '1250-3HA',
        price: '$365.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2F1250%20verticals%2F1250a-3.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/1250-3HA--florence-verticals-1250-3-alum.html',
      },
      {
        title: 'Florence Collection Drop Box 120 Series',
        sku: '120 Series',
        price: '$316.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2Fauthflorence%2F120.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/120%20Series--florence-collection-drop-box-120-series.html',
      },
      {
        title: 'Florence Verticals 1250-4-Alum',
        sku: '1250-4HA',
        price: '$485.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2F1250%20verticals%2F1250a-4.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/1250-4HA--florence-verticals-1250-4-alum.html',
      },
      {
        title: 'Florence Verticals 1250-5 Alum',
        sku: '1250-5HA',
        price: '$601.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2F1250%20verticals%2F1250a-5.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/1250-5HA--florence-verticals-1250-5-alum.html',
      },
      {
        title: 'Florence Verticals 1250-6 Alum',
        sku: '1250-6HA',
        price: '$720.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2F1250%20verticals%2F1250a-6.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/1250-6HA--florence-verticals-1250-6-alum.html',
      },
      {
        title: 'Florence Verticals 1250-7 Alum',
        sku: '1250-7HA',
        price: '$834.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2F1250%20verticals%2F1250a-7.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/1250-7HA--florence-verticals-1250-7-alum.html',
      },
      {
        title: '1570 Type II CBU Florence 12 Door',
        sku: '1570-12',
        price: '$2,616.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2F1570%20CBU%20on%20white%20like%20Houtz%2F1570-12PG.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/1570-12--1570-type-ii-cbu-florence-12-door.html',
      },
      {
        title: '1570 Type III Florence CBU 16 Door',
        sku: '1570-16',
        price: '$2,821.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2F1570%20CBU%20on%20white%20like%20Houtz%2F1570-16BK.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/1570-16--1570-type-iii-florence-cbu-16-door.html',
      },
      {
        title: '1570-13V2 Florence Traditional 13 Door CBU',
        sku: '1570-13V2',
        price: '$3,602.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2F1570V2%20CBU%2F1570-13V2SD.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/1570-13V2--1570-13v2-florence-traditional-13-door-cbu.html',
      },
      {
        title: '1570-16V2 Florence Traditional 16 Door CBU',
        sku: '1570-16V2',
        price: '$3,667.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2F1570V2%20CBU%2F1570-16V2WH.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/1570-16V2--1570-16v2-florence-traditional-16-door-cbu.html',
      },
    ],
  },
  {
    route:
      '/6m8/commercial-mailboxes-lockers/centralized-delivery-mailboxes-and-kiosks.html',
    label: 'Centralized Delivery Mailboxes & Kiosks',
    sourceUrl:
      'https://www.midatlanticmailboxes.com/6m8/commercial-mailboxes-lockers/centralized-delivery-mailboxes-and-kiosks.html',
    total: 253,
    products: [
      {
        title: 'Florence Verticals 1250-3-Alum',
        sku: '1250-3HA',
        price: '$365.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2F1250%20verticals%2F1250a-3.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/1250-3HA--florence-verticals-1250-3-alum.html',
      },
      {
        title: 'Florence Collection Drop Box 120 Series',
        sku: '120 Series',
        price: '$316.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2Fauthflorence%2F120.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/120%20Series--florence-collection-drop-box-120-series.html',
      },
      {
        title: 'Florence Verticals 1250-4-Alum',
        sku: '1250-4HA',
        price: '$485.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2F1250%20verticals%2F1250a-4.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/1250-4HA--florence-verticals-1250-4-alum.html',
      },
      {
        title: 'Florence Verticals 1250-5 Alum',
        sku: '1250-5HA',
        price: '$601.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2F1250%20verticals%2F1250a-5.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/1250-5HA--florence-verticals-1250-5-alum.html',
      },
      {
        title: 'Florence Verticals 1250-6 Alum',
        sku: '1250-6HA',
        price: '$720.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2F1250%20verticals%2F1250a-6.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/1250-6HA--florence-verticals-1250-6-alum.html',
      },
      {
        title: 'Florence Verticals 1250-7 Alum',
        sku: '1250-7HA',
        price: '$834.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2F1250%20verticals%2F1250a-7.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/1250-7HA--florence-verticals-1250-7-alum.html',
      },
      {
        title: '1570 Type II CBU Florence 12 Door',
        sku: '1570-12',
        price: '$2,616.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2F1570%20CBU%20on%20white%20like%20Houtz%2F1570-12PG.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/1570-12--1570-type-ii-cbu-florence-12-door.html',
      },
      {
        title: '1570 Type III Florence CBU 16 Door',
        sku: '1570-16',
        price: '$2,821.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2F1570%20CBU%20on%20white%20like%20Houtz%2F1570-16BK.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/1570-16--1570-type-iii-florence-cbu-16-door.html',
      },
      {
        title: '1570-13V2 Florence Traditional 13 Door CBU',
        sku: '1570-13V2',
        price: '$3,602.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2F1570V2%20CBU%2F1570-13V2SD.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/1570-13V2--1570-13v2-florence-traditional-13-door-cbu.html',
      },
      {
        title: '1570-16V2 Florence Traditional 16 Door CBU',
        sku: '1570-16V2',
        price: '$3,667.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2F1570V2%20CBU%2F1570-16V2WH.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/1570-16V2--1570-16v2-florence-traditional-16-door-cbu.html',
      },
    ],
  },
  {
    route: '/6m8/commercial-mailboxes-lockers/parcel-lockers.html',
    label: 'Parcel Lockers',
    sourceUrl:
      'https://www.midatlanticmailboxes.com/6m8/commercial-mailboxes-lockers/parcel-lockers.html',
    total: 22,
    products: [
      {
        title: 'Florence 1590 Outdoor Parcel Locker',
        sku: '1590T1',
        price: '$2,358.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2F1590%20series%2F1590-T1BK.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/1590T1--florence-1590-outdoor-parcel-locker.html',
      },
      {
        title: '4C11S-2P Single Column 4C Horizontal Mailbox',
        sku: '4C11S-2P',
        price: '$811.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2FNew%204C%20line%2F4C%20Recessed%20tagged%20and%20recessed%202016%2F4C11S-2PGS.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/4C11S-2P--4c11s-2p-single-column-4c-horizontal-mailbox.html',
      },
      {
        title: '4C11D-4P Double Column 4C Horizontal Mailbox',
        sku: '4C11D-4P',
        price: '$1,668.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2FNew%204C%20line%2F4C%20Recessed%20tagged%20and%20recessed%202016%2F4C11D-4PAB.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/4C11D-4P--4c11d-4p-double-column-4c-horizontal-mailbox.html',
      },
      {
        title: '4C12S-2P Single Column 4C Horizontal Mailbox',
        sku: '4C12S-2P',
        price: '$1,000.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2FNew%204C%20line%2F4C%20Recessed%20tagged%20and%20recessed%202016%2F4C12S-2PBK.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/4C12S-2P--4c12s-2p-single-column-4c-horizontal-mailbox.html',
      },
      {
        title: '4C12D-4P Double Column 4C Horizontal Mailbox',
        sku: '4C12D-4P',
        price: '$1,978.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2FNew%204C%20line%2F4C%20Recessed%20tagged%20and%20recessed%202016%2F4C12D-4PDB.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/4C12D-4P--4c12d-4p-double-column-4c-horizontal-mailbox.html',
      },
      {
        title: '4C14S-2P Single Column 4C Horizontal Mailbox',
        sku: '4C14S-2P',
        price: '$1,232.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2FNew%204C%20line%2F4C%20Recessed%20tagged%20and%20recessed%202016%2F4C14S-2PBK.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/4C14S-2P--4c14s-2p-single-column-4c-horizontal-mailbox.html',
      },
      {
        title: '4C14S-3P Single Column 4C Horizontal Mailbox',
        sku: '4C14S-3P',
        price: '$1,210.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2FNew%204C%20line%2F4C%20Recessed%20tagged%20and%20recessed%202016%2F4C14S-3PSS.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/4C14S-3P--4c14s-3p-single-column-4c-horizontal-mailbox.html',
      },
      {
        title: '4C15S-3P Single Column 4C Horizontal Mailbox',
        sku: '4C15S-3P',
        price: '$1,261.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2FNew%204C%20line%2F4C%20Recessed%20tagged%20and%20recessed%202016%2F4C15S-3PBK.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/4C15S-3P--4c15s-3p-single-column-4c-horizontal-mailbox.html',
      },
      {
        title: '4C16S-3P Single Column 4C Horizontal Mailbox',
        sku: '4C16S-3P',
        price: '$1,176.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2FNew%204C%20line%2F4C%20Recessed%20tagged%20and%20recessed%202016%2F4C16S-3PAB.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/4C16S-3P--4c16s-3p-single-column-4c-horizontal-mailbox.html',
      },
      {
        title: 'Versatile 4C Depot 16H - 6 Parcel Locker Package',
        sku: '4C16D-6P-D',
        price: '$4,060.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2FVario%20Depots%2F4C16D-6P-DSS.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/4C16D-6P-D--versatile-4c-depot-16h-6-parcel-locker-package.html',
      },
    ],
  },
  {
    route:
      '/6m8/commercial-mailboxes-lockers/replacement-commercial-locks-hinges-doors.html',
    label: 'Commercial Replacement Locks, Hinges & Doors',
    sourceUrl:
      'https://www.midatlanticmailboxes.com/6m8/commercial-mailboxes-lockers/replacement-commercial-locks-hinges-doors.html',
    total: 4,
    products: [
      {
        title: '4C and CBU replacement Comp/National lock w/3 keys',
        sku: 'K91910',
        price: '$26.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2FK91910.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/K91910--4c-and-cbu-replacement-comp-national-lock-w-3-keys.html',
      },
      {
        title: 'Replacement cylinder',
        sku: 'K91910B',
        price: '$17.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2F91910B.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/K91910B--replacement-cylinder.html',
      },
      {
        title: 'Hudson replacement tenant Lock/Keys for 4B+ and Vertical units',
        sku: 'K30809',
        price: '$14.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fauthflorence%2FK30809.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/K30809--hudson-replacement-tenant-lock-keys-for-4b-and-vertical-units.html',
      },
      {
        title: 'Salsbury Replacement Vertical locks w/2 keys - 5 pack',
        sku: '3590-5',
        price: '$90.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSalsbury%2FVertical%20Mailboxes%2F3590-5.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/3590-5--salsbury-replacement-vertical-locks-w-2-keys-5-pack.html',
      },
    ],
  },
]
